import React from 'react';
import Ship2Land from 'components/Land/Ship2Land';
import CustomerForm from 'components/CustomerForm';

const LandFlow = ({ step, initialValues }) => {

  return (
    <>
      <>{step == 1 && (<Ship2Land />)}</>
      <>{step == 2 && (<CustomerForm initialValues={initialValues} />)}</>
    </>
  );
};

export default LandFlow;